import React, { useState } from 'react';
import { Box, Modal } from '@mui/material';

import DynamicTable from '../../components/Table/Table';

const TeamsTable = ({ tableData, isTableLoading, teamLeads, handleModalAction }) => {
  const columns = [
    { id: 'userName', label: 'NAME', type: 'text' },
    { id: 'userEmail', label: 'EMAIL', type: 'text' },
    { id: 'memberFunction', label: 'FUNCTION', type: 'text' },
    { id: 'functionValue', label: 'REGION /CHANNEL /CUSTOMER', type: 'text' },
    { id: 'editBtn', label: 'EDIT', type: 'button' }
  ];
  const [openModal, setOpenModal] = useState(false);

  return (
    <Box
      component="section"
      sx={{
        p: 2,
        borderRadius: '8px',
        backgroundColor: '#FBFCFE',
        boxShadow: '4px 0px 24px -2px #005CBC14'
      }}>
      <DynamicTable
        originalColumns={columns}
        originalData={tableData}
        tableName="Team"
        isTableLoading={isTableLoading}
        isSearch
        isCollapseButton={false}
        isColumnFilter
        handleModalAction={handleModalAction}
      />
      {openModal && (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"></Modal>
      )}
    </Box>
  );
};

export default TeamsTable;
